import { toast } from 'sonner';
import { ALL_TASK_FIELD_FLAGS, type TaskFieldFlags } from '../../lib/tasks/taskFields';
import {
  useTaskFieldFlags,
  useUpdateTaskFieldFlags,
} from '../../hooks/queries/useCabinetSettings';
import { cn } from '../../lib/cn';

const OPTIONS: { key: keyof TaskFieldFlags; label: string }[] = [
  { key: 'tags', label: 'Étiquettes' },
  { key: 'priority', label: 'Priorité' },
  { key: 'sections', label: 'Sections' },
];

export function TaskFieldFlagsSection() {
  const { data: flags = ALL_TASK_FIELD_FLAGS } = useTaskFieldFlags();
  const update = useUpdateTaskFieldFlags();

  function toggle(key: keyof TaskFieldFlags, checked: boolean) {
    const next: TaskFieldFlags = { ...flags, [key]: checked };
    update.mutate(next, {
      onError: (err) => {
        toast.error(
          err instanceof Error ? err.message : 'Impossible d’enregistrer les champs',
        );
      },
    });
  }

  return (
    <section className="rounded-cime border border-neutral-200 bg-white p-4 space-y-3">
      <div>
        <h2 className="text-lg font-semibold text-cime-text-primary">Champs</h2>
        <p className="text-sm text-cime-text-muted mt-1">
          Étiquettes, priorité et sections sur les tâches. Une case décochée disparaît de la
          création, de l’édition, de la liste et des tâches types. Rien n’est effacé.
        </p>
      </div>
      <div className="flex flex-col gap-2">
        {OPTIONS.map(({ key, label }) => {
          const checked = flags[key];
          return (
            <label
              key={key}
              htmlFor={`task-field-${key}`}
              className={cn(
                'flex items-center gap-3 rounded-md border p-3 cursor-pointer',
                checked ? 'border-cime-primary bg-cime-primary/5' : 'border-neutral-200',
              )}
            >
              <input
                id={`task-field-${key}`}
                type="checkbox"
                className="h-4 w-4 accent-cime-primary"
                checked={checked}
                disabled={update.isPending}
                onChange={(e) => toggle(key, e.target.checked)}
              />
              <span className="text-sm font-medium text-cime-text-primary">{label}</span>
            </label>
          );
        })}
      </div>
    </section>
  );
}
